function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: transparent;\n    color: ", ";\n    border: 1px solid ", ";\n\n    &:hover {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &:focus {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &:active {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n    }\n\n    &:disabled {\n      background-color: transparent;\n      color: ", ";\n      border-color: ", ";\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getTheme } from '../Theme';
import ButtonBase from './ButtonBase';
var ButtonOutline = styled(ButtonBase)(_templateObject(), function (_ref) {
  var color = _ref.color;
  return css(_templateObject2(), getTheme("colors." + color + ".500"), getTheme("colors." + color + ".500"), getTheme("colors." + color + ".600"), getTheme("colors." + color + ".600"), getTheme("colors." + color + ".600"), getTheme("colors." + color + ".600"), getTheme("colors." + color + ".700"), getTheme("colors." + color + ".700"), getTheme("colors." + color + ".500"), getTheme("colors." + color + ".500"));
});
ButtonOutline.propTypes = _extends({
  color: PropTypes.string
}, ButtonBase.propTypes);
export default ButtonOutline;